<template>
  <div>
    <JumpcloudGoPageLoader :userEmail="userEmail" />
  </div>
</template>

<script>
import JumpcloudGoPageLoader from 'client/components/JumpcloudGoPageLoader.vue';
import durtService from 'client/services/durtService';
import oidcClientService from 'client/services/oidcClientService';

export default {
  name: 'JumpCloudOidcCallback',

  components: {
    JumpcloudGoPageLoader,
  },

  data() {
    return {
      userEmail: '',
    };
  },

  created() {
    this.durtRegister();
  },

  methods: {
    async durtRegister() {
      let userState = '';
      try {
        // in case processSigninResponse fails we will loose the user state
        // should handle the state our selves or we can rely on this
        const oidcResponse = await oidcClientService.processSigninResponse();
        this.userEmail = oidcResponse.profile.email;
        userState = oidcResponse.userState;
        if (!oidcResponse?.id_token) {
          throw new Error('id_token not found in oidc response');
        }
        await durtService.register(oidcResponse.id_token);
        window.location.replace(`/login${userState ? '?' : ''}${userState}`);
      } catch (e) {
        // if the user is logged in (which in the normal case he is,
        // because we are the relying party and the authority)
        // the login error won't appear in the notification with code below
        window.location.replace(`/login?error=goError&${userState}`);
        // should we show him a warning notification in this page (before redirecting him)
        // and in case he is logged in we can show a continue button
      }
    },
  },
};
</script>
